export default __webpack_public_path__ + "static/media/slider-img24.189249f6.jpg";